var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    className: "svg-plus",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 9.2C14.0353 9.2 9.2 14.0353 9.2 20C9.2 25.9647 14.0353 30.8 20 30.8C25.9647 30.8 30.8 25.9647 30.8 20C30.8 14.0353 25.9647 9.2 20 9.2ZM8 20C8 13.3726 13.3726 8 20 8C26.6274 8 32 13.3726 32 20C32 26.6274 26.6274 32 20 32C13.3726 32 8 26.6274 8 20Z",
    fill: "#8F27C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 20C14 19.6686 14.2686 19.4 14.6 19.4H25.4C25.7314 19.4 26 19.6686 26 20C26 20.3314 25.7314 20.6 25.4 20.6H14.6C14.2686 20.6 14 20.3314 14 20Z",
    fill: "#8F27C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0004 14C20.3318 14 20.6004 14.2686 20.6004 14.6V25.4C20.6004 25.7314 20.3318 26 20.0004 26C19.669 26 19.4004 25.7314 19.4004 25.4V14.6C19.4004 14.2686 19.669 14 20.0004 14Z",
    fill: "#8F27C7"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Plus.6303a89c9906814ed7c7a5ce768a8b16.svg";